import styled from '@emotion/styled';

export const PublicPageCardTitle = styled.h1`
    font-size: 24px;
    line-height: 28px;
    font-weight: 700;
    margin: 0 auto 24px auto;
`;
